import {
  Button,
  Chip,
  Dialog,
  Grid,
  MenuItem,
  Tooltip,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import ReactCountryFlag from "react-country-flag";
import Dropzone from "react-dropzone";
import { colors } from "../../styles/color";
import AutoComplete from "../../components/AutoComplete";
import TextInput from "../../components/TextInput";
import CountryAutoComplete from "../../components/CountryAutoComplete";
import { SelectInput } from "../../components/SelectInput";
import {
  Close,
  Doller,
  InfoEmail,
  Line,
  RemoveChannelIcon,
  Search,
  EditThumbnail,
  UploadIcon,
} from "../../assets/icons";
import ErrorTextBox from "../../components/common/ErrorTextBox";
import {
  isEmpty,
  onlyNumbers,
  validateMinSec,
} from "../../utils/commanFunctions/commanFunctions";
import BreadCrumb from "../../components/common/BreadCrumb";
import CkEditoComponent from "../../components/common/CkEditorComponent";
import ContentCategoryAutoComplete from "../../components/layout/ContentCategoryAutoComplete";
import { CloudUpload, InfoOutlined } from "@mui/icons-material";
import {
  fetchCountryeDetails,
  setCountryState,
} from "../../redux/features/country/countrySlice";
import {
  fetchCategoryDetails,
  setCategoryState,
} from "../../redux/features/channelCategory/channelCategorySlice";
import {
  fetchAudioDetails,
  setAudioState,
} from "../../redux/features/channelAudioList/channelAudioSlice";
import { fetchAccountCreate } from "../../redux/features/addAccount/addAccountSlice";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchContentCategoryDetails,
  setContentCategory,
} from "../../redux/features/contentCategory/contentCategorySlice";
import { ToastMessage } from "../../helpers/ToastMessage";
import { toast } from "react-toastify";
import { durationTime } from "../../constants/menuItems";
import { fetchDelectAccount } from "../../redux/features/deleteAccount/deleteAccountSlice";
import { setLoading } from "../../redux/features";
import {
  fetchAccountDeatils,
  setAccountDetailsState,
} from "../../redux/features/accountDetail/accountDetailSlice";

interface Props {
  toggle?: boolean;
  setToggle?: any;
  channelDetails?: any;
  accountDetails?: any;
}

interface FormErrors {
  name?: string;
  category?: string;
  uploadTime?: string;
  country?: any;
  language?: string;
  addChannel?: string;
  email?: string;
  description?: string;
  file?: string;
  valueData?: string;
  videoType?: any;
  contentCat?: any;
  minimumPrice?: string;
}

const staticContentCategoryData = [
  { id: 1, name: "Tutorials" },
  { id: 2, name: "Reviews" },
  { id: 3, name: "Vlogs" },
  { id: 4, name: "How-to Guides" },
  { id: 5, name: "News & Updates" },
  { id: 6, name: "Comedy" },
  { id: 7, name: "Documentary" },
  { id: 8, name: "Live Streams" },
  { id: 9, name: "Interviews" },
  { id: 10, name: "Product Demos" },
];

export const EditAccount = ({
  toggle,
  setToggle,
  channelDetails,
  accountDetails,
}: Props) => {
  const dispatch = useDispatch();
  const [description, setDescription] = useState("");
  const { audioData } = useSelector((state: any) => state?.audio);
  const [language, setLanguage] = useState<any[]>([]);
  const [uploadTime, setUploadTime] = useState<any>();
  const { countryData } = useSelector((state: any) => state.country);
  const [country, setCountry] = useState<any[]>([]);
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [countryOptions, setCountryOptions] = useState<any[]>([]);
  const { categoryData } = useSelector((state: any) => state?.category);
  const [category, setCategory] = useState<any>("");
  const [valueData, setValueData] = useState("");
  const [minimumPrice, setMinimumPrice] = useState<any>();
  const [bothFiled, setIsBothField] = useState(false);
  const [isVideoFieldDisplay, setIsVideoFieldDisplay] = useState(false);
  const [isShortVideoDisplay, setIsShortVideoDisplay] = useState(false);
  const [file, setFile] = useState(null);
  const [email, setEmail] = useState<any>("");
  const [contentCat, setContentCat] = useState<any[]>([]);
  const [contentCatData, setContentcatData] = useState<any[]>([]);
  const [name, setName] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [thumbnail, setThumbnail] = useState<any>(null);
  // const [videoType, setVideoType] = useState<any>("1");
  const [username, setUsername] = useState<string>("");
  const navigate = useNavigate();

  // const [token, __, removeToken] = useCookies([
  //   "accessToken",
  //   "refreshToken",
  //   "googleToken",
  //   "role",
  // ]);

  // Get accountDetails from Redux state
  const { accountDetails: reduxAccountDetails } = useSelector(
    (state: any) => state?.accountDetails
  );

  // Use accountDetails from props or Redux state
  const currentAccountDetails = accountDetails || reduxAccountDetails;
  const token = localStorage.getItem("instagramCode");

  const validTLDs = [
    "com",
    "org",
    "net",
    "gov",
    "edu",
    "mil",
    "int",
    "eu",
    "us",
    "uk",
    "ca",
    "jp",
    "cn",
    "au",
  ];
  const validTLDRegex = new RegExp(`(${validTLDs.join("|")})$`, "i");
  const schema = yup.object().shape({
    name: yup.string().required("Name is required"),
    email: yup
      .string()
      .test("valid-email", "Invalid email address", (value) => {
        if (value) {
          const parts = value.split("@");
          if (parts.length === 2) {
            const username = parts[0];
            const domain = parts[1];

            if (
              username === "" ||
              username.startsWith(".") ||
              domain.startsWith(".") ||
              username.includes("..") ||
              domain.includes("..") ||
              domain.startsWith("-") ||
              username.endsWith(".") ||
              !/^[ -~\t\n\r]+$/.test(value)
            ) {
              return false;
            } else if (domain.startsWith("[") && domain.endsWith("]")) {
              const ip = domain.substring(1, domain.length - 1);
              if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(ip)) {
                const parts = ip.split(".");
                for (let part of parts) {
                  if (parseInt(part) < 0 || parseInt(part) > 255) {
                    return false;
                  }
                }
                return true;
              }
            } else if (domain.includes(".")) {
              const domainParts = domain.split(".");
              const tld = domainParts[domainParts.length - 1];

              if (validTLDRegex.test(tld) || tld === "name") {
                return true;
              }
            }
            return false;
          }
          return false;
        }
        return false;
      })
      .required("Email is required"),
    category: yup.string().required("Please select a category"),
    uploadTime: yup.string().required("Please select a upload time"),
    country: yup
      .array()
      .min(1, "Please select at least one country")
      .required("Please select a country"),
    language: yup
      .array()
      .min(1, "Please select at least one video audio language")
      .required("Please select video audio language"),
    description: yup
      .string()
      .min(10, "Description must be at least 10 characters")
      .required("Description is required"),
    file: yup.string().required("Drag and drop or browser to upload thumbnail"),
    valueData: yup
      .string()
      .test(
        "not-00-0e",
        'Value cannot be "00:0e" or contain invalid characters, only numbers are allowed',
        (value: any) => {
          if (value === "00:0e" || /[^\d:]/.test(value)) {
            return false;
          }
          return true;
        }
      ),
  });

  // Event handlers
  const handleChange = (value: any) => {
    setCountry(value);
    setFormErrors({
      ...formErrors,
      country: "",
    });
  };

  const handleContentcategory = (value: any) => {
    setContentCat(value);
    setFormErrors({
      ...formErrors,
      contentCat: "",
    });
  };

  const languageHandleChange = (value: any) => {
    setLanguage(value);
    setFormErrors({
      ...formErrors,
      language: "",
    });
  };

  const handleDrop = (acceptedFiles: any) => {
    const uploadedFile = acceptedFiles[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      setFormErrors({
        ...formErrors,
        file: "",
      });
    }
  };

  const handleClear = () => {
    setFile(null);
    setThumbnail(null);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmitSave = async () => {
    // Validation logic here
    const errors: FormErrors = {};

    if (!name || name.trim() === "") {
      errors.name = "Name is required";
    }

    if (!category) {
      errors.category = "Category is required";
    }

    if (!email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      errors.email = "Email is invalid";
    }

    if (country.length === 0) {
      errors.country = "At least one country is required";
    }

    if (language.length === 0) {
      errors.language = "At least one language is required";
    }

    if (contentCat.length === 0) {
      errors.contentCat = "At least one content category is required";
    }

    if (!uploadTime) {
      errors.uploadTime = "Upload time is required";
    }

    if (!description || description.trim() === "") {
      errors.description = "Description is required";
    }

    if (minimumPrice && !/^\d+$/.test(minimumPrice)) {
      errors.minimumPrice = "Please enter integer value like 20";
    }

    // debugger
    console.log("errors", errors);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      // debugger
      try {
        dispatch(setLoading(true));

        const formData = new FormData();
        // if(!token){
        //   return;
        // }

        // Add form fields to FormData
        formData.append("name", name);
        formData.append("username", username);
        formData.append("category_id", category);
        formData.append(
          "minimum_price",
          minimumPrice ? parseInt(minimumPrice).toString() : ""
        );
        formData.append(
          "minimum_short_price",
          minimumPrice ? parseInt(minimumPrice).toString() : ""
        );
        formData.append("email", email);
        formData.append("video_length", valueData);
        formData.append("upload_time", uploadTime);
        formData.append("video_type", "1");
        formData.append("auth_type", "1");
        // formData.append("token_code", token);

        // Add count fields from accountDetails
        if (currentAccountDetails) {
          formData.append("id", currentAccountDetails.id || "");
          formData.append(
            "account_user_id",
            currentAccountDetails.channel_id || ""
          );
          formData.append("follows_count", currentAccountDetails.follows_count);
          formData.append(
            "followers_count",
            currentAccountDetails.followers_count
          );
          formData.append("media_count", currentAccountDetails.media_count);
        }

        // Add content categories
        if (contentCat && contentCat.length > 0) {
          contentCat.forEach((contentCatDetails: any) => {
            formData.append("content_cat_id[]", contentCatDetails?.id);
          });
        }

        // Add countries
        if (country && country.length > 0) {
          country.forEach((c: any) => {
            formData.append("country[]", c.id);
          });
        }

        // Add languages
        if (language && language.length > 0) {
          language.forEach((l: any) => {
            formData.append("audio_id[]", l.id);
          });
        }

        formData.append("description", description);

        // Append file if exists
        if (file) {
          formData.append("thumbnail", file);
        }

        const response = await dispatch(fetchAccountCreate(formData));

        if (response.payload?.status) {
          // Refresh account details to reflect changes immediately
          if (currentAccountDetails?.id) {
            const updatedAccountResponse = await dispatch(
              fetchAccountDeatils(currentAccountDetails.id)
            );
            if (updatedAccountResponse.payload?.status) {
              dispatch(
                setAccountDetailsState(updatedAccountResponse.payload.data)
              );
            }
          }

          ToastMessage({
            type: "success",
            message: "Account updated successfully!",
          });
          setToggle(false); // Close the edit form
          navigate("/dashboard/social/instagram");
        } else {
          ToastMessage({
            type: "error",
            message:
              response.payload?.message ||
              response.error?.message ||
              "Failed to update account",
          });
        }
      } catch (error: any) {
        ToastMessage({
          type: "error",
          message:
            error.message ||
            error.payload?.message ||
            "Failed to update account",
        });
      } finally {
        dispatch(setLoading(false));
      }
    }
  };

  const handleDelete = async () => {
    try {
      dispatch(setLoading(true));
      const response = await dispatch(
        fetchDelectAccount(currentAccountDetails?.id)
      );

      if (response.payload?.status) {
        ToastMessage({
          type: "success",
          message: "Account deleted successfully!",
        });
        setOpen(false);
        setToggle(false); // Close the edit form
        navigate("/dashboard/social/emptyInsta"); // Navigate to emptyInsta page
      } else {
        ToastMessage({
          type: "error",
          message: response.payload?.message || "Failed to delete account",
        });
      }
    } catch (error: any) {
      ToastMessage({
        type: "error",
        message: error.message || "Failed to delete account",
      });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleRemoveAccount = () => {
    setOpen(true); // Open the confirmation dialog
  };
  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const res = await dispatch(fetchCountryeDetails());

        if (res && res.payload) {
          setCountryOptions(res.payload);

          dispatch(setCountryState(res.payload));
        } else {
          console.log("data is not found");
        }
      } catch (error) {
        console.error("Error fetching country data:", error);
      }
    };
    fetchCountryData();
  }, [dispatch]);

  useEffect(() => {
    const fetchAudioData = async () => {
      try {
        const res = await dispatch(fetchAudioDetails());
        dispatch(setAudioState(res));
      } catch (error) {
        console.log("Data is not found", error);
      }
    };

    fetchAudioData();
  }, []);

  useEffect(() => {
    const contentCategoryData = async () => {
      const data = await dispatch(fetchContentCategoryDetails(1));

      if (data) {
        setContentcatData(data?.payload);
      } else {
        toast.error("Data not found");
      }
    };
    contentCategoryData();
  }, []);

  useEffect(() => {
    const fetchCategoryData = async () => {
      try {
        const data = await dispatch(fetchCategoryDetails(1)); // type=1 for Instagram
        dispatch(setCategoryState(data));

        console.log("Category API response: ", data);
      } catch (error) {
        console.log("Category data fetch error:", error);
      }
    };
    fetchCategoryData();
  }, [dispatch]);
  useEffect(() => {
    console.log("categoryData from Redux: ", categoryData);
    console.log("Current category state: ", category);
    console.log("Current uploadTime state: ", uploadTime);
  }, [categoryData, category, uploadTime]);

  // Populate form fields with account details
  useEffect(() => {
    if (currentAccountDetails) {
      setName(currentAccountDetails?.channel_name || "");
      setEmail(currentAccountDetails?.email || "");
      setCategory(currentAccountDetails?.category_id?.toString() || "");
      setUploadTime(currentAccountDetails?.upload_time?.toString() || "");
      setValueData(currentAccountDetails?.video_length || "");
      setMinimumPrice(
        currentAccountDetails?.minimum_price
          ? parseInt(currentAccountDetails?.minimum_price).toString()
          : ""
      );
      setDescription(currentAccountDetails?.description || "");
      // setVideoType(currentAccountDetails?.video_type?.toString() || "1");
      setThumbnail(currentAccountDetails?.thumbnail || null);
      setUsername(currentAccountDetails?.username || "");

      // Set countries
      if (
        currentAccountDetails?.countries &&
        Array.isArray(currentAccountDetails.countries)
      ) {
        setCountry(currentAccountDetails.countries);
      }

      // Set languages
      if (
        currentAccountDetails?.audio &&
        Array.isArray(currentAccountDetails.audio)
      ) {
        setLanguage(currentAccountDetails.audio);
      }

      // Set content categories
      if (
        currentAccountDetails?.content_category &&
        Array.isArray(currentAccountDetails.content_category)
      ) {
        const contentCategories = currentAccountDetails.content_category
          .map((item: any) => item.content_category_details?.[0])
          .filter(Boolean);
        setContentCat(contentCategories);
      }

      console.log("Account Details loaded:", currentAccountDetails);
      console.log("Category ID:", currentAccountDetails?.category_id);
      console.log("Upload Time:", currentAccountDetails?.upload_time);
      console.log("Username:", currentAccountDetails?.username);
    }
  }, [currentAccountDetails]);

  useEffect(() => {
    fetchAccountCreate();
  }, [fetchAccountCreate]);

  // useEffect(() => {
  //   if (channelDetails) {
  //     // setChannelId(channelDetails?.channel_id);
  //     setUploadTime(channelDetails?.upload_time);
  //     setEmail(channelDetails?.email);
  //     setValueData(isEmpty(channelDetails?.video_length));
  // }, [channelDetails]);

  return (
    <Box
      sx={{
        "& .MuiAppBar-root": {
          position: "sticky",
        },
      }}
    >
      <BreadCrumb
        isClickable={false}
        name1={"Social"}
        name2={"Instagram"}
        name3={"Edit Account"}
        isClickable2={true}
        onClick2={() => {
          setToggle(false);
        }}
        onClick={() => {
          navigate("/dashboard/social/instagram");
        }}
      />
      <Box p="0px 16px" mt={"16px"}>
        <Box
          sx={{
            height: "100%",
            background: colors.dark[800],
            borderRadius: "12px",
            color: "white",
            p: { md: "70px 100px 20px", xs: "20px" },
          }}
        >
          <Grid container spacing={2}>
            <Grid item sm={6} xs={12}>
              <TextInput
                title="Username"
                placeholder="Username"
                value={username}
                // readOnly={true}
                onChange={(e) => {
                  setUsername(e.target.value);
                  setFormErrors((prev) => ({
                    ...prev,
                    username: "",
                  }));
                }}
                textFieldStyle={{
                  height: "52px",
                  "& .MuiInputBase-input": {
                    WebkitTextFillColor: colors.gray[300],
                    backgroundColor: colors.dark[600],
                  },
                }}
              />

              <Box mt={3}>
                <TextInput
                  title="Name"
                  placeholder="Enter your name"
                  value={name}
                  textFieldStyle={{height: "52px"}}
                  onChange={(e) => {
                    setName(e.target.value);
                    setFormErrors((prev) => ({
                      ...prev,
                      name: "",
                    }));
                  }}
                />
                {/* {formErrors.name && <ErrorTextBox>{formErrors.name}</ErrorTextBox>} */}
              </Box>
              {formErrors.name && (
                <ErrorTextBox>{formErrors.name}</ErrorTextBox>
              )}

              <Box mt={3}>
                <TextInput
                  title="Minimum Price for marketing (optional)"
                  placeholder="Enter minimum price"
                  value={minimumPrice || ""}
                  textFieldStyle={{height: "52px"}}
                  onChange={(e: any) => {
                    const value = e.target.value;
                    console.log("🚀 ~ value:", value);
                    // Only allow integers (no decimals, no special characters)
                    // if (/^\d*$/.test(value)) {
                    if (value === "" || parseInt(value) >= 0) {
                      setMinimumPrice(value); // Store as string to preserve format
                      setFormErrors((prev) => ({
                        ...prev,
                        minimumPrice: "",
                      }));
                    }
                    // } else {
                    //   console.log("🚀 ~ value:", value)
                    //   setMinimumPrice(value);
                    //   setFormErrors((prev) => ({
                    //     ...prev,
                    //     minimumPrice: "Minimum price must be a integer",
                    //   }));
                    // }
                  }}
                  StartIcon={
                    <Box display={"flex"} alignItems={"center"}>
                      <Box pr={"20px"}>
                        <Doller />
                      </Box>
                      <Box>
                        <Line />
                      </Box>
                    </Box>
                  }
                />
                {formErrors.minimumPrice && (
                  <ErrorTextBox>{formErrors.minimumPrice}</ErrorTextBox>
                )}
              </Box>

              <Box mt={3}>
                <TextInput
                  title="Average video upload duration in second (optional)"
                  placeholder="05:50 min:sec"
                  value={valueData}
                  textFieldStyle={{height: "52px"}}
                  onKeyDown={(e: any) => {
                    if (e.target.value.length === 2 && e.keyCode !== 8) {
                      if (e.target.value.indexOf(":") === -1) {
                        e.target.value = e.target.value + ":";
                      }
                      var str = e.target.value.split(":");
                      if (str[0].length === 1) {
                        e.target.value = "0" + str[0];
                      }
                    }
                  }}
                  onChange={(e: any) => {
                    let input = e.target.value;
                    if (input !== "00:0e" && input.length <= 5) {
                      if (validateMinSec(input) || input === "") {
                        setValueData(input);
                        setFormErrors({
                          ...formErrors,
                          valueData: "",
                        });
                      } else {
                        setValueData(input);
                        setFormErrors({
                          ...formErrors,
                          valueData: "Invalid time format",
                        });
                      }
                    } else if (input === "00:0e") {
                      setValueData(input);
                      setFormErrors({
                        ...formErrors,
                        valueData: 'Value cannot be "00:0e"',
                      });
                    } else if (input === "") {
                      setValueData(input);
                      setFormErrors({
                        ...formErrors,
                        valueData: "",
                      });
                    }
                  }}
                />
              </Box>
              <ErrorTextBox>{formErrors.valueData}</ErrorTextBox>

              <Box mt={3}>
                <CountryAutoComplete
                  placeholder={`${country?.length ? "" : "Select country"}`}
                  title="Target Audience Country"
                  options={countryOptions || []}
                  EndIcon={<Search />}
                  disableClearable
                  value={country}
                  getOptionLabel={(option: any) => option?.name}
                  style={{height: "52px"}}
                  onChange={(value) => handleChange(value)}
                  renderTags={(value: any, getTagProps: any) =>
                    value.map((option: any, index: any) => (
                      <Chip
                        key={option?.id}
                        label={option?.name}
                        {...getTagProps({ index })}
                        deleteIcon={<Close />}
                      />
                    ))
                  }
                  renderOption={(props: any, option: any) => {
                    return (
                      <Box
                        component="li"
                        sx={{
                          display: "flex",
                          "& .MuiAutocomplete-noOptions": {
                            color: colors.basics.white,
                          },
                          background: colors.dark[600],
                          "& .icons": {
                            width: "28px !important",
                            height: "28px !important",
                            borderRadius: "8px",
                          },
                        }}
                        {...props}
                      >
                        <Typography
                          mr="14px"
                          variant="body2"
                          alignItems={"center"}
                          display={"flex"}
                        >
                          <ReactCountryFlag
                            countryCode={option.code}
                            svg
                            className="icons"
                          />
                        </Typography>
                        <Typography variant="body2">{option.name} </Typography>
                      </Box>
                    );
                  }}
                />
                {formErrors.country && (
                  <ErrorTextBox>{formErrors.country}</ErrorTextBox>
                )}
              </Box>
            </Grid>

            <Grid item sm={6} xs={12}>
              <SelectInput
                placeholder="Select Category"
                title="Instagram post/reels category"
                renderValue={(selected: any) => {
                  if (
                    selected === "" ||
                    selected === null ||
                    selected === undefined
                  ) {
                    return (
                      <Typography
                        variant="body2"
                        sx={{ color: colors.gray[500], fontSize: "14px" }}
                      >
                        {""}
                      </Typography>
                    );
                  }
                  const selectedItem = categoryData?.find(
                    (item: any) => item.id.toString() === selected.toString()
                  );
                  return selectedItem ? selectedItem.name : "";
                }}
                children={
                  categoryData && Array.isArray(categoryData)
                    ? categoryData.map((item: any) => {
                        return (
                          <MenuItem key={item.id} value={item.id.toString()}>
                            <Typography variant="body2" lineHeight="24px">
                              {item.name}
                            </Typography>
                          </MenuItem>
                        );
                      })
                    : []
                }
                data={
                  categoryData && Array.isArray(categoryData)
                    ? categoryData.map((category: any) => category.name)
                    : []
                }
                style={{height: "52px"}}
                onChange={(e) => {
                  const categoryId = e.target.value;
                  setCategory(categoryId);
                  setFormErrors((prev) => ({
                    ...prev,
                    category: "",
                  }));
                }}
                value={category || ""}
                defaultOpen={false}
              />
              {formErrors.category && (
                <ErrorTextBox>{formErrors.category}</ErrorTextBox>
              )}
              {/* <Box mt={3}>
                <Typography variant="body2" sx={{ color: "gray" }}>
                  Video Type
                </Typography>

                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="all"
                  name="radio-buttons-group"
                  value={videoType}
                  onChange={(event: any) => {
                    setVideoType(event.target.value);
                    if (event.target.value === "2") {
                      setIsVideoFieldDisplay(true);
                      setIsShortVideoDisplay(false);
                      setIsBothField(false);
                    } else if (event.target.value === "3") {
                      setIsShortVideoDisplay(true);
                      setIsVideoFieldDisplay(false);
                      setIsBothField(false);
                    } else if (event.target.value === "1") {
                      setIsBothField(true);
                      setIsShortVideoDisplay(false);
                      setIsVideoFieldDisplay(false);
                    }
                  }}
                  sx={{
                    "& .MuiRadio-root": {
                      color: colors.gray[500],
                    },
                    "& .Mui-checked": {
                      color: colors.basics.primary,
                      "& svg": {
                        fill: colors.basics.primary,
                      },
                    },
                    "& .MuiFormControlLabel-label": {
                      color: colors.gray[300],
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "21px",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      backgroundColor: "#1D1D1D",
                      paddingY: "6px",
                      paddingX: "16px",
                      borderRadius: "8px",
                    }}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Both"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label="Full Video"
                    />
                    <FormControlLabel
                      value="3"
                      control={<Radio />}
                      label="Shorts (Reels)"
                    />
                  </Box>
                </RadioGroup>
                <ErrorTextBox>{formErrors?.videoType}</ErrorTextBox>
              </Box> */}

              <Box mt={3}>
                <TextInput
                  title="Contact Email"
                  placeholder="Enter your email address"
                  value={email}
                  textFieldStyle={{height: "52px"}}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setFormErrors((prev) => ({
                      ...prev,
                      email: "",
                    }));
                  }}
                  EndIcon={
                    <Tooltip
                      title="Add an Email associated with your Instagram account."
                      arrow
                    >
                      <InfoOutlined />
                    </Tooltip>
                  }
                />
                {formErrors.email && (
                  <ErrorTextBox>{formErrors.email}</ErrorTextBox>
                )}
              </Box>

              <Box mt={3}>
                <SelectInput
                  title="Post/Reels upload duration time"
                  placeholder="Select duration time"
                  renderValue={(selected: any) => {
                    if (
                      selected === "" ||
                      selected === null ||
                      selected === undefined
                    ) {
                      return (
                        <Typography
                          variant="body2"
                          sx={{ color: colors.gray[500] }}
                        >
                          {""}
                        </Typography>
                      );
                    }
                    const selectedItem = durationTime.find(
                      (item: any) => item.id.toString() === selected.toString()
                    );
                    return selectedItem ? selectedItem?.time : "";
                  }}
                  data={durationTime}
                  style={{height: "52px"}}
                  onChange={(e) => {
                    const uploadTimeId = e?.target?.value;
                    setUploadTime(uploadTimeId);
                    setFormErrors((prev) => ({
                      ...prev,
                      uploadTime: "",
                    }));
                  }}
                  value={uploadTime || ""}
                  defaultOpen={false}
                  children={durationTime?.map((option: any, index: any) => {
                    return (
                      <MenuItem
                        value={option?.id.toString()}
                        key={option?.id}
                        sx={{
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <Typography
                          mr="14px"
                          variant="body2"
                          alignItems={"center"}
                          display={"flex"}
                        >
                          {option?.time}
                        </Typography>
                      </MenuItem>
                    );
                  })}
                />
                {formErrors.uploadTime && (
                  <ErrorTextBox>{formErrors.uploadTime}</ErrorTextBox>
                )}
              </Box>

              <Box mt={3}>
                <ContentCategoryAutoComplete
                  title="Content Category"
                  options={contentCatData?.map((option: any) => option)}
                  EndIcon={<Search />}
                  disableClearable
                  value={contentCat}
                  getOptionLabel={(option: any) => option.name}
                  style={{height: "52px"}}
                  onChange={(value) => handleContentcategory(value)}
                  renderTags={(value: any, getTagProps: any) =>
                    value.map((option: any, index: any) => (
                      <Chip
                        key={option.id}
                        label={option.name}
                        {...getTagProps({ index })}
                        deleteIcon={<Close />}
                      />
                    ))
                  }
                  renderOption={(props: any, option: any) => {
                    return (
                      <Box
                        component="li"
                        sx={{
                          display: "flex",
                          "& .MuiAutocomplete-noOptions": {
                            color: colors.basics.white,
                          },
                          background: colors.dark[600],
                        }}
                        {...props}
                      >
                        <Typography
                          mr="14px"
                          variant="body2"
                          alignItems={"center"}
                          display={"flex"}
                        ></Typography>
                        <Typography variant="body2">{option.name} </Typography>
                      </Box>
                    );
                  }}
                />
                <ErrorTextBox>{formErrors?.contentCat}</ErrorTextBox>
              </Box>

              <Box mt={3}>
                <CountryAutoComplete
                  title="Post/Reels/Video audio language"
                  placeholder={`${language?.length ? "" : "Select language"}`}
                  options={audioData?.map((option: any) => option)}
                  EndIcon={<Search />}
                  disableClearable
                  value={language}
                  getOptionLabel={(option: any) => option?.name}
                  style={{height: "52px"}}
                  onChange={(value) => languageHandleChange(value)}
                  renderTags={(value: any, getTagProps: any) =>
                    value.map((option: any, index: any) => (
                      <Chip
                        key={option?.id}
                        label={option?.name}
                        {...getTagProps({ index })}
                        deleteIcon={<Close />}
                      />
                    ))
                  }
                  renderOption={(props: any, option: any) => {
                    return (
                      <Box
                        component="li"
                        sx={{
                          display: "flex",
                          "& .MuiAutocomplete-noOptions": {
                            color: colors.basics.white,
                          },
                          background: colors.dark[600],
                          "& .icons": {
                            width: "28px !important",
                            height: "28px !important",
                            borderRadius: "8px",
                          },
                        }}
                        {...props}
                      >
                        <Typography
                          mr="14px"
                          variant="body2"
                          alignItems={"center"}
                          display={"flex"}
                        >
                          <ReactCountryFlag
                            countryCode={option.code}
                            svg
                            className="icons"
                          />
                        </Typography>
                        <Typography variant="body2">{option.name} </Typography>
                      </Box>
                    );
                  }}
                />
                {formErrors.language && (
                  <ErrorTextBox>{formErrors.language}</ErrorTextBox>
                )}
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box mt={3}>
                <Typography variant="body2" color={colors.gray[300]}>
                  Description
                </Typography>
                <Box
                  sx={{
                    "& .ck-editor ": {
                      backgroundColor: colors.dark[600],
                      padding: "20px",
                      borderRadius: "10px",
                      height: "120px",
                    },
                    ".ck.ck-editor__main>.ck-editor__editable": {
                      backgroundColor: "transparent",
                      border: 0,
                      height: "80px",
                    },
                    "& .ck-editor__top ": {
                      display: "none",
                    },
                    "& .ck-content p ": {
                      marginTop: "0 !important",
                      marginBottom: "15px !important",
                    },
                    "& .ck-content p a": {
                      color: "#A175FF !important",
                      textDecoration: "none",
                    },
                    "& .ck-content p:last-child ": {
                      marginBottom: "0 !important",
                    },
                  }}
                >
                  <div style={{ fontWeight: "500" }}>
                    <CkEditoComponent
                      data={description}
                      setData={(value: string) => {
                        setDescription(value);
                        setFormErrors((prev) => ({
                          ...prev,
                          description: "",
                        }));
                      }}
                      placeholder={
                        "Write short description about Instagram account..."
                      }
                    />
                  </div>
                </Box>
                {formErrors.description && (
                  <ErrorTextBox>{formErrors.description}</ErrorTextBox>
                )}
              </Box>

              <Box mt={"24px"}>
                <Box mb={"10px"}>
                  <Typography
                    variant="body2"
                    lineHeight={"140%"}
                    color={colors.gray[300]}
                  >
                    Upload Thumbnail
                  </Typography>
                </Box>
                <Dropzone
                  accept={{ "image/png": [".png", ".jpeg", ".jpg"] }}
                  onDrop={handleDrop}
                >
                  {({ getRootProps, getInputProps }) => (
                    <Box
                      {...getRootProps()}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "left",
                        justifyContent: "left",
                        padding: file || thumbnail ? "0px" : "25px",
                        border:
                          file || thumbnail
                            ? "none"
                            : `1px dashed ${colors.dark[100]}`,
                        borderRadius: "10px",
                        cursor: "pointer",
                        position: "relative",
                        width: "100%",
                        overflow: "hidden",
                      }}
                    >
                      <input {...getInputProps()} accept="image/*" />
                      {file || thumbnail ? (
                        <Box
                          sx={{
                            position: "relative",
                            textAlign: "left",
                            justifyContent: "left",
                            display: "flex",
                            width: "fit-content",
                          }}
                        >
                          <Box
                            sx={{
                              maxWidth: "100%",
                              maxHeight: "200px",
                              position: "relative",
                            }}
                          >
                            <img
                              src={
                                file ? URL?.createObjectURL(file) : thumbnail
                              }
                              alt="Preview"
                              style={{
                                // maxWidth: "166px",
                                maxHeight: "166px",
                                borderRadius: "8px",
                              }}
                            />
                            <Box
                              sx={{
                                position: "absolute",
                                background: "#1d1d1d99",
                                transform: "translate(-50%, -50%)",
                                top: "50%",
                                left: "50%",
                                borderRadius: "8px",
                                cursor: "pointer",
                                p: "8px 8px 8px 8px",
                                textAlign: "left",
                                justifyContent: "left",
                                display: "flex",
                              }}
                              onClick={handleClear}
                            >
                              <EditThumbnail />
                            </Box>
                          </Box>
                        </Box>
                      ) : (
                        <Box textAlign={"center"}>
                          <Box>
                            <UploadIcon />
                          </Box>
                          <Box>
                            <Typography variant="body2" lineHeight={"24px"}>
                              Drag and drop or browse
                            </Typography>
                            <Typography
                              variant="body2"
                              fontSize={"14px"}
                              lineHeight={"140%"}
                              color={colors.gray[300]}
                            >
                              Image size should be 1080px x 1080px (Max. File
                              size: 5MB)
                            </Typography>
                          </Box>
                        </Box>
                      )}
                    </Box>
                  )}
                </Dropzone>
                {formErrors.file && (
                  <ErrorTextBox>{formErrors.file}</ErrorTextBox>
                )}
              </Box>

              <Box mt={3} display="flex" justifyContent="start" gap={"15px"}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: colors.basics.primary,
                    width: { sm: "180px", xs: "100%" },
                  }}
                  onClick={handleSubmitSave}
                >
                  Save Changes
                </Button>
                <Box
                  sx={{
                    width: "100%",
                    "& .MuiButtonBase-root": {
                      border: "1px solid #E33437",
                      "&:hover": {
                        background: colors.dark[800],
                        border: "1px solid #E33437",
                      },
                    },
                  }}
                >
                  <Button
                    sx={{
                      background: colors.dark[800],
                      color: "#E33437",
                      width: { sm: "180px", xs: "100%" },
                    }}
                    variant="outlined"
                    onClick={handleRemoveAccount}
                  >
                    Remove Account
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Box>
            <Dialog
              className="edit-modal"
              open={open}
              maxWidth={"xl"}
              onClose={handleClose}
              sx={{
                "& .MuiDialog-paper": {
                  background: colors.dark[600],
                  borderRadius: "12px",
                },
              }}
            >
              <Box p={"28px"}>
                <Box m={"auto"} textAlign="center" p={"0px 12px"}>
                  <Box>
                    <RemoveChannelIcon />
                  </Box>
                  <Box mt="30px">
                    <Typography variant="body1" fontWeight={700}>
                      Are you sure?
                    </Typography>
                  </Box>
                  <Box mt="15px">
                    <Typography variant="body2" color={colors.gray[300]}>
                      Do you really want to remove this Instagram account?
                    </Typography>
                  </Box>
                </Box>
                <Box
                  display="flex"
                  justifyContent={"space-between"}
                  width="100%"
                  mt={"32px"}
                >
                  <Box width="100%" mr="10px">
                    <Button
                      variant="outlined"
                      sx={{ width: "100%" }}
                      onClick={handleClose}
                    >
                      Cancel
                    </Button>
                  </Box>
                  <Box
                    width="100%"
                    ml="10px"
                    sx={{
                      "& .MuiButtonBase-root": {
                        "&:hover": {
                          background: "#E33437",
                        },
                      },
                    }}
                  >
                    <Button
                      sx={{ width: "100%", background: "#E33437" }}
                      onClick={handleDelete}
                    >
                      Remove
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Dialog>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
